import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow page builder functionality.
 */
export class BuilderOperations {
  constructor(private client: BaserowClient) {}
  
  // Builder methods will be implemented here
} 